import { BufferWriter, Writer } from "protobufjs";
import { INotificationRepository } from "../../../domain/repository/notification_repository";
import { IApiClient } from "../client";
import { common, entity } from "../rpc/api";
import { getToken } from "./bind_token";

class NotificationAPI implements INotificationRepository {
  constructor(readonly apiClient: IApiClient) {}

  public getAll = (
    page: number,
    offset: number
  ): Promise<entity.INotification[]> => {
    return new Promise<entity.INotification[]>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: common.Pager = new common.Pager();
          req.page = page;
          req.offset = offset;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.NotificationService/GetAll",
            token,
            common.Pager.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res: entity.NotificationList =
            entity.NotificationList.decode(binary);
          resolve(res.items);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  };

  public getUnReadCount = (): Promise<number> => {
    return new Promise<number>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: common.Empty = new common.Empty();
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.NotificationService/GetUnReadCount",
            token,
            common.Empty.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res: common.Count = common.Count.decode(binary);
          resolve(res.count as number);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  };

  public read = (): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: common.Empty = new common.Empty();
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.NotificationService/Read",
            token,
            common.Empty.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          resolve();
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  };
}

const createNotificationAPI = (
  apiClient: IApiClient
): INotificationRepository => {
  return new NotificationAPI(apiClient);
};

export { createNotificationAPI };



// WEBPACK FOOTER //
// ./src/infra/api/service/notification_api.ts